import React from 'react'

const Loader = () => {
  return <div className='spinner-3'></div>
}

export default Loader
